import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { EditorRightsRoutes } from './editorrights.routes';
import { ListEditorRightsComponent } from './list-editorrights/list-editorrights.component';
import { FormEditorRightsComponent } from './_components/form-editorrights/form-editorrights.component';
import { AddEditorRightsComponent } from './add-editorrights/add-editorrights.component';
import { EditEditorRightsComponent } from './edit-editorrights/edit-editorrights.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [EditorRightsRoutes, SharedDocumalisModule, TranslateModule],
    declarations: [ListEditorRightsComponent, AddEditorRightsComponent, EditEditorRightsComponent, FormEditorRightsComponent],
})
export class EditorRightsModule {}
